import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  position: relative;
  max-width: 100%;

  & > .arrow {
    align-items: center;
    background-color: #FFF;
    border: none;
    border-radius: 50%;
    bottom: 50%;
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: center;
    margin: auto 0;
    position: absolute;
    top: 50%;
    width: 40px;

    & > img {
      height: 24px;
      width: 24px;
    }

    &.previous {
      left: -20px;
    }

    &.next {
      right: -20px;
      transform: rotate(180deg);
    }
  }

  & > .dots {
    align-items: center;
    bottom: 32px;
    display: flex;
    gap: 8px;
    justify-content: center;
    position: absolute;
    width: 100%;

    & > .dot {
      background-color: #FFF;
      border: 1px solid #FFF;
      border-radius: 50%;
      cursor: pointer;
      height: 8px;
      max-width: 8px;
      transition: all 0.3s ease-in-out;
      width: 100%;

      &:hover {
        background-color: #00A988;
      }

      &.active {
        background-color: #00A988;
        border: 1px solid #00A988;
        border-radius: 8px;
        max-width: 32px;
      }
    }
  }

`

export const Carousel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;

  & > .slides {
    display: flex;
    height: 100%;
    transition: transform 0.5s ease;

    & > .slide {
      cursor: grab;
      min-width: 100%;
      user-select: none;

      &.click-blocked * {
        pointer-events: none;
      }

      &:active {
        cursor: grabbing;
      }
    }
  }

  @media (max-width: 911px) {
    & > .slides {
      gap: 16px;

      & > .slide {
        box-shadow: none;
        height: auto;
      }
    }
  }
`
